import React, { Component, Fragment } from "react";
import { Table, message, Spin, Statistic, Row, Col } from "antd";

//Component import
import ReportLayout from "../../../pageLayouts/Report";
import { fetchApi, fetchExcelApi } from "../../../../services/api";
import ScollBarView from "react-double-scrollbar";
import Empty from "../../../components/Custom/Empty";

//Utility
import { mapKeys, isEmpty, cloneDeep } from "lodash";
import { sortFunction } from "../../../../utility/sorter";
import { parserFunction } from "./parserFunctions";
import moment from "moment";
import columns from "./columns";

class MonthwiseFarmProductionActivitiesReportPeriodGroup extends Component {
  componentRef = React.createRef();
  state = {
    data: [],
    coloums: [],
    loading: false,
    blockNoList: [],
    blockNumber: null,
    block_uuid: null,
    areaNoList: [],
    areaNumber: null,
    area_uuid: null,
    DwarfType: null,
    DwarfTypeList: [],
    DwarfType_uuid: null,
    isopen: false,
    typeOfGroup: null,
    type: "Blockwise",
    period: [],
    areaVisible: false,
    dwarfTypeVisible: false,
    groupType: 0,
    value: null
  };

  componentDidMount() {
    this.fetchBlockNo();
    this.fetchDwarfType();
  }

  fetchFarmProductionActivitiesPeriodGroup = () => {
    let {
      block_uuid,
      area_uuid,
      DwarfType_uuid,
      groupType,
      period
    } = this.state;
    if (period.length > 0 && block_uuid) {
      this.setState({ loading: true });
      fetchApi(
        `/regular-reports/monthwise-farm-production-activities?period=${period[0]}&to_date=${period[1]}&block.uuid=${block_uuid}&group_type=${groupType}&area.uuid=${area_uuid}&tree.uuid=${DwarfType_uuid}`,
        "get"
      ).then(res => {
        if (res)
          this.setState({
            data: parserFunction(res.blocks)
          });
        else message.error("Internal Server Error!");
        this.setState({ loading: false });
      });
    } else {
      this.setState({
        data: []
      });
    }
  };

  fetchBlockNo = () =>
    fetchApi("/blocksuuid", "get").then(data =>
      this.setState({ blockNoList: sortFunction(data, "blockNoFull") })
    );
  fetchDwarfType = () =>
    fetchApi("/tree_types?type=1", "get").then(data =>
      this.setState({ DwarfTypeList: data })
    );

  //year functions
  handleOpenChange = status => {
    if (status) {
      this.setState({ isopen: true });
    } else {
      this.setState({ isopen: false });
    }
  };

  onDropDownChangeHandler = (type, item) => {
    let { blockNoList, areaNoList, DwarfTypeList } = this.state;
    switch (type) {
      case "block":
        if (item) {
          fetchApi(
            `/areasuuid?block.uuid=${
              cloneDeep(blockNoList).filter(it => it.blockNoFull == item)[0]
                .uuid
            }`,
            "get"
          ).then(res => this.setState({ areaNoList: res }));
          this.setState(
            {
              blockNumber: item ? item : null,
              block_uuid: item
                ? cloneDeep(this.state.blockNoList).filter(
                    each => each.blockNoFull === item
                  )[0].uuid
                : null
            },
            () => this.fetchFarmProductionActivitiesPeriodGroup()
          );
        } else {
          this.setState(
            {
              blockNumber: null,
              block_uuid: null,
              areaNoList: [],
              areaNumber: null,
              area_uuid: null
            },
            () => this.fetchFarmProductionActivitiesPeriodGroup()
          );
        }
        break;

      case "typeOfGroup":
        if (item) {
          this.setState({ typeOfGroup: item }, () => {
            if (this.state.typeOfGroup == "AREAWISE") {
              this.setState(
                {
                  type: "Areawise",
                  areaVisible: true,
                  dwarfTypeVisible: false,
                  groupType: 1,
                  DwarfType: null,
                  DwarfType_uuid: null
                },
                () => this.fetchFarmProductionActivitiesPeriodGroup()
              );
            } else if (this.state.typeOfGroup == "TYPEWISE") {
              this.setState(
                {
                  type: "Typewise",
                  areaVisible: false,
                  dwarfTypeVisible: true,
                  groupType: 2,
                  areaNumber: null,
                  area_uuid: null
                },
                () => this.fetchFarmProductionActivitiesPeriodGroup()
              );
            } else {
              this.setState(
                {
                  type: "Blockwise",
                  areaVisible: false,
                  dwarfTypeVisible: false,
                  groupType: 0,
                  areaNumber: null,
                  area_uuid: null,
                  DwarfType: null,
                  DwarfType_uuid: null
                },
                () => this.fetchFarmProductionActivitiesPeriodGroup()
              );
            }
          });
        } else {
          this.setState(
            {
              blockNumber: null,
              block_uuid: null,
              areaNoList: [],
              areaNumber: null,
              area_uuid: null
            },
            () => this.fetchFarmProductionActivitiesPeriodGroup()
          );
        }
        break;

      case "area":
        this.setState(
          {
            areaNumber: item ? item : null,
            area_uuid: item
              ? cloneDeep(areaNoList).filter(it => it.areaNo == item)[0].uuid
              : null
          },
          () => this.fetchFarmProductionActivitiesPeriodGroup()
        );
        break;

      case "dwarfType":
        this.setState(
          {
            DwarfType: item ? item : null,
            DwarfType_uuid: item
              ? cloneDeep(DwarfTypeList).filter(it => it.code == item)[0].uuid
              : null
          },
          () => this.fetchFarmProductionActivitiesPeriodGroup()
        );
        break;

      default:
        if (item.length > 0) {
          this.setState(
            {
              value: item,
              period: [
                moment(item[0]).format("YYYY-MM"),
                moment(item[1]).format("YYYY-MM")
              ],
              isopen: false
            },
            () => this.fetchFarmProductionActivitiesPeriodGroup()
          );
        } else {
          this.setState(
            {
              value: null,
              period: [],
              isopen: false,
              data: []
            },
            () => this.fetchFarmProductionActivitiesPeriodGroup()
          );
        }
    }
  };

  generateExcel = () => {
    let {
      block_uuid,
      area_uuid,
      DwarfType_uuid,
      groupType,
      period
    } = this.state;
    if (period.length > 0 && block_uuid) {
      fetchExcelApi(
        `/regular-reports/monthwise-farm-production-activities?period=${period[0]}&to_date=${period[1]}&block.uuid=${block_uuid}&group_type=${groupType}&area.uuid=${area_uuid}&tree.uuid=${DwarfType_uuid}`,
        "get"
      ).then();
    }
  };

  render() {
    let {
      data,
      loading,
      value,
      isopen,
      blockNoList,
      areaNoList,
      DwarfTypeList,
      areaVisible,
      dwarfTypeVisible,
      areaNumber,
      blockNumber,
      DwarfType,
      period,
      block_uuid,
      type
    } = this.state;

    let JSX =
      data && data.length > 0 ? (
        <Fragment>
          {/* <h3>BLOCKWISE WEEKLY EMASCULATION SUMMARY FOR        {data.month}</h3>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Statistic title="BLOCK NO." value={data.blocks[0].block_no} />
                                </Col>
                            </Row> */}

          <h3>
            {type +
              "/Monthwise Farm Production Activities Reports for the Period of " +
              moment(period[0]).format("MMM YYYY") +
              " - " +
              moment(period[1]).format("MMM YYYY")}
          </h3>
          <ScollBarView>
            <Table
              //className="regular-reports-tables month-wise-report-table"
              className="table-align-left-all regular-reports-tables bordered-table-head"
              bordered
              columns={columns}
              dataSource={data}
              bordered
              size="small"
              pagination={false}
              //className="month-wise-report-table"
            />
          </ScollBarView>
        </Fragment>
      ) : period.length > 0 && block_uuid ? (
        <Empty description="No Data Found" />
      ) : (
        <Empty description={"Select Block No. and Period"} />
      );
    const buttonList =
      data && data.length > 0
        ? [
            {
              label: "Excel",
              icon: "file-text",
              onClickHandler: () => this.generateExcel()
            },
            {
              label: "Print",
              icon: "diff",
              toolTip: "Suggestion: Print in Landscape",
              reference: this.componentRef
            }
          ]
        : null;

    return (
      <ReportLayout
        title="Monthwise Farm Production Activities Reports - Selected Period & Selected Group"
        // title={
        //   data && data.length > 0
        //     ? type +
        //       "/Monthwise Farm Production Activities Reports - Selected Period & Selected Group for the Period of " +
        //       moment(period[0]).format("MMM YYYY") +
        //       " - " +
        //       moment(period[1]).format("MMM YYYY")
        //     : "Monthwise Farm Production Activities Reports - Selected Period & Selected Group"
        // }
        buttonList={buttonList}
        dropDownList={[
          {
            label: "Block",
            listItems: cloneDeep(blockNoList).map(it => it.blockNoFull),
            value: blockNumber ? blockNumber : undefined,
            changeHandler: it => this.onDropDownChangeHandler("block", it)
          },
          {
            label: "Type of Group",
            listItems: ["BLOCKWISE", "AREAWISE", "TYPEWISE"],
            hasInitial: true,
            changeHandler: it => this.onDropDownChangeHandler("typeOfGroup", it)
          },
          {
            label: "Area",
            listItems: cloneDeep(areaNoList).map(it => it.areaNo),
            disabled: blockNumber ? false : true,
            value: areaNumber ? areaNumber : undefined,
            visible: areaVisible,
            changeHandler: it => this.onDropDownChangeHandler("area", it)
          },
          {
            label: "Dwarf Type",
            listItems: cloneDeep(DwarfTypeList).map(it => it.code),
            visible: dwarfTypeVisible,
            value: DwarfType ? DwarfType : undefined,
            changeHandler: it => this.onDropDownChangeHandler("dwarfType", it)
          },
          {
            label: "Period",
            mode: ["month", "month"],
            value: value,
            type: "range",
            format: "MM/YYYY",
            open: isopen,
            showTime: true,
            onOk: date => this.onDropDownChangeHandler("period", date),
            onOpenChange: this.handleOpenChange,
            onPanelChange: val => this.setState({ value: val }),
            changeHandler: () => this.onDropDownChangeHandler("period", [])
          }
        ]}
      >
        <div ref={this.componentRef}>
          <Spin
            spinning={loading}
            size="large"
            wrapperClassName="regular-reports-container"
          >
            {JSX}
          </Spin>
        </div>
      </ReportLayout>
    );
  }
}

export default MonthwiseFarmProductionActivitiesReportPeriodGroup;
